export const CARTADD = "productsNCart/addCart";
export const CARTINCREMENT = "productsNCart/incrementCart";
export const CARTDECREMENT = "productsNCart/decrementCart";